module.exports = "https://cdn.hellotech.com/client-assets/tvmount61plus_d5fc348cc486a66f9fae320ff1978e15.png";